<template>
    <div>
        <alert
            :variant="alert.variant"
            dismissible
            :mensagens="alert.mensagens"
            :value="alert.exibir"
            @input="alertDismissed">
        </alert>

        <!-- Dados Edicao -->
        <b-card>
            <b-row >
                <b-col class="col-md-2">
                    <b-form-group
                        :label="acao == 'view' || edicaoPublicada ? 'Edição' : 'Edição *'"
                        label-size="sm" >
                        <b-form-input
                            @keyup.native='alteraDados'
                            v-model="edicaoLocal.numero_edicao"
                            :disabled="acao == 'view' || edicaoPublicada"
                            aria-describedby="feedback_numero_edicao"
                            :state="validarEstadoCampo(edicaoLocal.numero_edicao)"
                            @keypress="$helper.somenteNumeros"
                            ></b-form-input>
                            <b-form-invalid-feedback id="feedback_numero_edicao">Campo Obrigatório.</b-form-invalid-feedback>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <b-form-group
                        :label="acao == 'view' || edicaoPublicada ? 'Tipo Edição' : 'Tipo Edição *'"
                        label-size="sm"    >
                        <b-form-radio-group
                            v-model="edicaoLocal.tipo_edicao"
                            :options="tipoEdicao.options"
                            @blur.native='alteraDados'
                            value-field="value"
                            text-field="text"
                            :disabled="acao == 'view' || edicaoPublicada"
                            aria-describedby="feedback_tipo_edicao"
                            :state="validarEstadoCampo(edicaoLocal.tipo_edicao)">
                        </b-form-radio-group>
                        <b-form-invalid-feedback id="feedback_tipo_edicao">Campo Obrigatório.</b-form-invalid-feedback>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col class="col-md-3">
                    <b-form-group
                        :label="acao == 'view' || edicaoPublicada ? 'Data Publicação' : 'Data Publicação *'"
                        label-size="sm">
                        <b-form-input
                            v-model="edicaoLocal.dt_publicacao"
                            @blur="changeDataHoraPublicacao"
                            @keyup.native='alteraDados'
                            type="date"
                            :disabled="acao == 'view' || edicaoPublicada"
                            max="2999-12-31"
                            aria-describedby="feedback_dt_publicacao"
                            :state="validarEstadoCampo(edicaoLocal.dt_publicacao)">
                        </b-form-input>
                        <b-form-invalid-feedback id="feedback_dt_publicacao">Campo Obrigatório.</b-form-invalid-feedback>
                    </b-form-group>
                </b-col>
                <b-col class="col-12 col-md-3">
                    <b-form-group lo
                        :label="acao == 'view' || edicaoPublicada ? 'Hora Publicação' : 'Hora Publicação *'"
                        label-size="sm">
                        <b-form-input
                            :disabled= verificarDtPublicacao
                            v-model="edicaoLocal.hr_publicacao"
                            @blur="changeDataHoraPublicacao"
                            @keyup.native='alteraDados'
                            type="time"
                            aria-describedby="feedback_hr_publicacao"
                            :state="validarEstadoCampo(edicaoLocal.hr_publicacao)">
                        </b-form-input>
                        <b-form-invalid-feedback id="feedback_hr_publicacao">Campo Obrigatório.</b-form-invalid-feedback>
                    </b-form-group>
                </b-col>
                <b-col class="col-md-3">
                    <b-form-group
                        label="Ano"
                        label-size="sm" >
                        <b-form-input
                            :disabled=true
                            v-model="edicaoLocal.ano_romanos_edicao">
                        </b-form-input>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row >
                <b-col class="text-right" >
                    <b-button
                        variant="success"
                        @click="salvar"
                        v-show="acao != 'view' && !edicaoPublicada"
                    >
                        <i class="fa fa-floppy-o pr-1"></i> Salvar
                    </b-button>
                </b-col>
            </b-row>
        </b-card>

        <!-- Capa -->
        <b-card class="mt-2">
            <b-row>
                <b-col class="col-md-9">
                    <b-form-group
                        label="Arquivo da Capa"
                        label-size="sm" >
                        <b-input-group >
                            <b-form-file
                                @input="inputCapa"
                                :accept="extPermitidasCapa.toString()"
                                :placeholder="placeholderArquivoCapa"
                                v-model="edicaoLocal.arquivo_capa"
                                :disabled="acao == 'view' || edicaoLocal.id == null || edicaoLocal.documento_capa.id != null"
                                size="sm"
                                ref="capaInput" >
                            </b-form-file>
                        </b-input-group>
                        <small class="form-text text-muted">* O tamanho máximo do arquivo de upload: 2MB</small>
                    </b-form-group>
                </b-col>
                <b-col class="col-3 mt-4 pt-2">
                    <b-row class=" ">
                        <b-col >
                            <b-link
                                @click="$helper.exibirDocumento($env.VUE_APP_URL_API, edicaoLocal.documento_capa.nome_minio, edicaoLocal.documento_capa.prefix)"
                                v-if="(edicaoLocal.documento_capa.id != null)">
                                <i class="fa fa-file-image-o fa-lg"></i>
                            </b-link>
                            <b-link
                                @click="excluirDocumentoCapa()"
                                v-if="(acao != 'view' && edicaoLocal.documento_capa.id != null)"
                                class="ml-3" >
                                <i class="fa fa-trash fa-lg"></i>
                            </b-link>
                        </b-col>
                    </b-row>
                </b-col>
            </b-row>
        </b-card>

        <!-- DOM Completo -->
        <b-card class="mt-2">
            <b-row>
                <b-col class="col-9">
                    <b-form-group
                        label="Arquivo do DOM Completo"
                        label-size="sm" >
                        <b-form-checkbox
                            id="ckb_inserir_dom_assinado"
                            v-model="inserirDomJaAssinado"
                            name="checkbox-1"
                            :value="true"
                            :unchecked-value="false"
                            :disabled="edicaoLocal.documento_jornal.id != null"                            
                            >
                            Inserir DOM já assinado
                        </b-form-checkbox>
                        <b-form-file
                            v-if="inserirDomJaAssinado"
                            @input="incluirDocumentoJornalJaAssinado"
                            :accept="extPermitidasJornal.toString()"
                            :placeholder="placeholderArquivoJornal"
                            v-model="edicaoLocal.arquivo_jornal"
                            ref="jornalAssinadoInput"
                            :disabled="acao == 'view' || edicaoLocal.id == null || edicaoLocal.documento_jornal.id != null"
                            size="sm"
                        >
                        </b-form-file>
                        <b-input-group  v-else>
                            <b-form-input
                                readonly
                                v-model="edicaoLocal.documento_jornal.nome_original"
                                placeholder="Clique para selecionar/alterar documento">
                            </b-form-input>
                            <b-input-group-append >
                           
                            <b-button
                                @click="exibirModalAssinaturaDigital()"
                                size="sm"
                                :disabled="acao == 'view' || edicaoLocal.id == null || edicaoLocal.documento_jornal.id != null"
                                variant="primary" >
                                Procurar
                            </b-button>
                        </b-input-group-append>

                        </b-input-group>
                    </b-form-group>
                </b-col>
                <b-col class="col-3 mt-5 pt-2">
                    <b-row class=" ">
                        <b-col >
                            <b-link
                                @click="abrirDocumentoJornal(edicaoLocal.documento_jornal)"
                                v-if="(edicaoLocal.documento_jornal.id != null)">
                                <i class="fa fa-file-pdf-o fa-lg"></i>
                            </b-link>
                            <b-link
                                @click="excluirDocumentoJornal()"
                                v-if="(acao != 'view' &&  edicaoLocal.documento_jornal.id != null)"
                                class="ml-3" >
                                <i class="fa fa-trash fa-lg"></i>
                            </b-link>
                        </b-col>
                    </b-row>
                </b-col>
            </b-row>
        </b-card>

        <modalAssinaturaDigital
            v-if="showModalAssinaturaDigital"
            titulo="DOM Completo - Assinatura Digital"
            @arquivoAssinadoBase64="obterArquivoDOMAssinado"
            :extensoesPermitidas="extPermitidasJornal"
            :exibirModal.sync="showModalAssinaturaDigital"
            :tamanhoArquivo="$constantes.documentos.TAMANHO_LIMITE_UPLOAD_JORNAL"
          >
        </modalAssinaturaDigital>
    </div>
</template>

<script>

import Alert from '../../../models/Alert'
import moment from 'moment';
import { validationMixin } from "vuelidate";
import Edicao from '../../../models/Edicao'
import Documento from '../../../models/Documento'
import { required } from "vuelidate/lib/validators";
import  modalAssinaturaDigital  from "../../../components/ModalAssinaturaDigital";

export default {

    mixins: [validationMixin],

    components: {
        modalAssinaturaDigital,
    },

    props: {
        edicao: { type: Edicao },
        acao: {type: String, default: ''}
    },

    data(){
        return {
            edicaoLocal: new Edicao(),
            tipoEdicao:{
                options: [
                    { text: '1ª Edição', value: 'P' },
                    { text: '2ª Edição', value: 'S' },
                    { text: 'Edição Extra', value: 'E' },
                ],
            },
            edicaoPublicada: false,
            alert: new Alert(),
            formAlterado:false,
            showModalAssinaturaDigital: false,
            extPermitidasCapa: [".jpg", ".png", ".gif"],
            extPermitidasJornal: [".pdf"],
            inserirDomJaAssinado: false
        }
    },
    validations: {
        numero_edicao: {
            required,
        },
        tipo_edicao: {
            required,
        },
        dt_publicacao: {
            required,
        },
        hr_publicacao: {
            required,
        }
    },


    computed: {
        verificarDtPublicacao(){
            return !this.edicaoLocal.hasOwnProperty('dt_publicacao') || this.edicaoLocal.dt_publicacao == '' ||
                    this.edicaoLocal.dt_publicacao == null || this.acao == 'view' || this.edicaoPublicada;
        },

        placeholderArquivoCapa(){
            return this.edicaoLocal.documento_capa.nome_original  == null ? 'Clique para selecionar/alterar documento' : this.edicaoLocal.documento_capa.nome_original;
        },

        placeholderArquivoJornal(){
            return this.edicaoLocal.documento_jornal.nome_original  == null ? 'Clique para selecionar/alterar documento' : this.edicaoLocal.documento_jornal.nome_original;
        },
    },

    methods: {
        alertDismissed(){
            this.alert = new Alert();
        },

        alteraDados(){
            this.formAlterado = true;
            this.$emit('formAlterado',this.formAlterado);
        },

        anoRomano(){
            if(this.edicaoLocal.dt_publicacao != null || this.edicaoLocal.dt_publicacao != ''){
                let anoZero = 1994;
                let anoAtual = parseInt(moment(this.edicaoLocal.dt_publicacao).format('YYYY'));
                let anoSub = anoAtual - anoZero;
                this.edicaoLocal.ano_romanos_edicao = this.$helper.romanos(anoSub);
            } else {
                this.edicaoLocal.ano_romanos_edicao = ''
            }
        },

        changeDataHoraPublicacao(){
            var regData = /(\d{4})-(\d{2})-(\d{2})/;
            var regHora = /(\d{2}):(\d{2})/;
            if(regData.test(this.edicaoLocal.dt_publicacao) && regHora.test(this.edicaoLocal.hr_publicacao)){
                let dataHoraAtual = moment().format('YYYY-MM-DD HH:mm');
                let dataHoraPublicacao = moment(this.edicaoLocal.dt_publicacao + " " + this.edicaoLocal.hr_publicacao).format('YYYY-MM-DD HH:mm');

                if(moment(dataHoraPublicacao).isBefore(dataHoraAtual)){
                    this.edicaoLocal.dt_publicacao = '';
                    this.edicaoLocal.hr_publicacao = '';
                    this.edicaoLocal.ano_romanos_edicao = '';

                    this.$helper.showAlert(this.alert,
                                           this.$constantes.alert.variants.WARNING,
                                           'A data e hora de publicação informadas é anterior à atual.');

                }else{
                    this.anoRomano();
                }
            }

        },

        incluir(edicao){
            this.$api.edicao.incluir(edicao)
                .then(response => {
                    if(response.status == 200 || response.status == 201){
                        this.edicaoLocal = new Edicao(response.data.data);

                        this.$emit('aposSalvar', this.edicaoLocal);

                        this.$router.push({ name: 'edicaoTabs', params: { id:this.edicaoLocal.id} });

                        this.$helper.showAlert(this.alert,
                                               this.$constantes.alert.variants.SUCCESS,
                                               'Registro inserido com sucesso!');
                    }
                })
                .catch(error => {
                        this.$helper.showAlert(this.alert,
                                               this.$constantes.alert.variants.DANGER,
                                               error.response.data.errors);
                });
        },

        editar(edicao){
            this.$api.edicao.editar(edicao.id, edicao)
                .then(response => {
                    if(response.status == 200 || response.status == 201){
                        this.edicaoLocal = new Edicao(response.data.data);

                        this.$emit('aposSalvar', this.edicaoLocal);

                        this.$helper.showAlert(this.alert,
                                               this.$constantes.alert.variants.SUCCESS,
                                               'Registro atualizado com sucesso!');
                    }
                })
                .catch(error => {
                        this.$helper.showAlert(this.alert,
                                               this.$constantes.alert.variants.DANGER,
                                               error.response.data.errors);
                });
        },

        validaCamposObrigatoriosPreenchidos() {
            return (this.edicaoLocal.numero_edicao != undefined &&
                    this.edicaoLocal.tipo_edicao &&
                    this.edicaoLocal.dt_publicacao &&
                    this.edicaoLocal.hr_publicacao );
        },

        salvar(){
            if(this.validaCamposObrigatoriosPreenchidos()){
                let edicao = new Edicao(this.edicaoLocal);
                delete edicao.documento_capa;
                delete edicao.arquivo_capa;
                delete edicao.documento_jornal;
                delete edicao.arquivo_jornal;

                if (edicao.id == null){
                    this.incluir(edicao);
                }else{
                    this.editar(edicao);
                }
                this.formAlterado = false;
                this.$emit('formAlterado',this.formAlterado);
            }else{
                this.$helper.showAlert(this.alert,
                                       this.$constantes.alert.variants.DANGER,
                                       'Existe(m) campo(s) obrigatório(s) não preenchido(s).');
            }
            this.$helper.scrollWindowToTop();
        },

        limparDocumentoCapa(){
            this.edicaoLocal.arquivo_capa = null;
            this.edicaoLocal.capa_documento_id = null;
            this.edicaoLocal.documento_capa = new Documento();
        },

        async incluirDocumentoCapa(){
            let params = {}
            params.nome_arquivo = this.edicaoLocal.arquivo_capa.name;

            await this.$helper.convertToBase64(this.edicaoLocal.arquivo_capa)
            .then(response => {
                params.arquivo= response;
            })
            .catch(error => {
                this.alert = {
                    variant: 'danger',
                    mensagens: 'Erro ao converter capa para base64: ' + error.response.data.errors,
                    exibir:true
                };
            });

            this.$api.edicao.incluirDocumentoCapa(this.edicaoLocal.id, params)
            .then(response => {
                if(response.status == 200 || response.status == 201){
                    this.edicaoLocal.documento_capa = new Documento(response.data.data);
                    this.edicaoLocal.capa_documento_id = this.edicaoLocal.documento_capa.id;

                    this.$helper.showAlert(this.alert,
                                           this.$constantes.alert.variants.SUCCESS,
                                           'Arquivo da capa inserido com sucesso!');
                }
            })
            .catch(error => {
                this.limparDocumentoCapa();

                this.$helper.showAlert(this.alert,
                                       this.$constantes.alert.variants.DANGER,
                                       error.response.data.errors);
            });
        },

        excluirDocumentoCapa(){
            let message = 'Confirma a exclusão do arquivo da Capa?';
            this.$helper.confirmaExclusao(this, message)
                .then(confirmado => {
                    if(confirmado){
                        this.$api.edicao.excluirDocumentoCapa(this.edicaoLocal.id)
                            .then(response => {
                                if(response.status == 200 || response.status == 201){
                                    this.limparDocumentoCapa();

                                    this.$helper.showAlert(this.alert,
                                                           this.$constantes.alert.variants.SUCCESS,
                                                           'Arquivo da capa excluído com sucesso!');
                                }
                            })
                            .catch(error => {
                                this.$helper.showAlert(this.alert,
                                                       this.$constantes.alert.variants.DANGER,
                                                       error.response.data.errors);
                            });
                    }
            });
        },

        verificaTamanhoArquivoCapaValido(){
            if(this.edicaoLocal.arquivo_capa != null) {
                if(this.edicaoLocal.arquivo_capa.size > this.$constantes.documentos.TAMANHO_LIMITE_UPLOAD_CAPA_JORNAL){
                    this.edicaoLocal.arquivo_capa =  null;
                    this.$helper.showAlert(this.alert,
                                           this.$constantes.alert.variants.WARNING,
                                           `Tamanho máximo do Arquivo da Capa deve ser de ${this.$helper.bytesToSize(this.$constantes.documentos.TAMANHO_LIMITE_UPLOAD_CAPA_JORNAL)}.`);

                    this.$helper.scrollWindowToTop();
                    return false;
                }
            }
            return true;
        },



        inputCapa(){
            if(this.edicaoLocal.arquivo_capa){
                if(!this.$helper.validaExtensaoArquivo(this.edicaoLocal.arquivo_capa.name, this.extPermitidasCapa)){
                    this.$helper.showAlert(this.alert,
                                           this.$constantes.alert.variants.WARNING,
                                           'Extensão do arquivo não suportada. Escolha arquivos com as extensões: ' +  this.extPermitidasCapa.toString());
                    this.$refs.capaInput.reset();
                    return;
                }

                if(!this.verificaTamanhoArquivoCapaValido()){
                    this.$refs.capaInput.reset();
                    return;
                }

                this.edicaoLocal.documento_capa.nome_original = this.edicaoLocal.arquivo_capa.name;
                this.incluirDocumentoCapa();
            }
        },

        getMaxNumeroEdicao(){
            return this.$api.edicao.maxNumeroEdicao()
                .then(response => {
                    return response.data.data;
                })
                .catch(error => {
                    this.$helper.showAlert(this.alert,
                                           this.$constantes.alert.variants.DANGER,
                                           `Erro ao obter o novo número de edição. ${error.response.data.errors}`);
                });
        },

        async setDefault(){
            var maxNumeroEdicao =  this.getMaxNumeroEdicao();
            this.edicaoLocal.numero_edicao = await maxNumeroEdicao + 1;
            this.edicaoLocal.tipo_edicao = 'P';
            this.edicaoLocal.dt_publicacao = moment().add(1,'days').format('YYYY-MM-DD'),
            this.edicaoLocal.hr_publicacao = '00:01';
            this.anoRomano();
        },

        limparDocumentoJornal(){
            this.edicaoLocal.arquivo_jornal = null;
            this.edicaoLocal.jornal_documento_id = null;
            this.edicaoLocal.documento_jornal = new Documento();
        },

        verificaTamanhoArquivoJornalJaAssinadoValido(){
            if(this.edicaoLocal.arquivo_jornal != null) {
                if(this.edicaoLocal.arquivo_jornal.size > this.$constantes.documentos.TAMANHO_LIMITE_UPLOAD_JORNAL){
                    this.edicaoLocal.arquivo_jornal =  null;
                    this.$helper.showAlert(this.alert,
                                           this.$constantes.alert.variants.WARNING,
                                           `Tamanho máximo do arquivo deve ser de ${this.$helper.bytesToSize(this.$constantes.documentos.TAMANHO_LIMITE_UPLOAD_JORNAL)}.`);

                    this.$helper.scrollWindowToTop();
                    return false;
                }
            }
            return true;
        },

        async incluirDocumentoJornalJaAssinado(){

            if(!this.$helper.validaExtensaoArquivo(this.edicaoLocal.arquivo_jornal.name, this.extPermitidasJornal)){
                this.$helper.showAlert(this.alert,
                                       this.$constantes.alert.variants.WARNING,
                                       'Extensão do arquivo não suportada. Escolha arquivos com as extensões: ' +  this.extPermitidasJornal.toString());
                this.$refs.jornalAssinadoInput.reset();
                return;
            }

            if(!this.verificaTamanhoArquivoJornalJaAssinadoValido()){
                this.$refs.jornalAssinadoInput.reset();
                return;
            }


            this.edicaoLocal.documento_jornal.nome_original = this.edicaoLocal.arquivo_jornal.name;

            await this.$helper.convertToBase64(this.edicaoLocal.arquivo_jornal)
            .then(response => {
                this.edicaoLocal.arquivo_jornal = response;
            })
            .catch(error => {
                this.alert = {
                    variant: 'danger',
                    mensagens: 'Erro ao converter capa para base64: ' + error.response.data.errors,
                    exibir:true
                };
            });
            this.incluirDocumentoJornal();
        },

        incluirDocumentoJornal(){
            this.$api.edicao.incluirDocumentoJornal(this.edicaoLocal.id, this.edicaoLocal.arquivo_jornal,
                                                    this.edicaoLocal.documento_jornal.nome_original,
                                                    this.edicaoLocal.documento_jornal.codigo_assinatura_digital)
                .then(response => {
                    if(response.status == 200 || response.status == 201){
                        this.edicaoLocal.documento_jornal = new Documento(response.data.data);
                        this.edicaoLocal.jornal_documento_id = this.edicaoLocal.documento_jornal.id;
                        this.$helper.showAlert(this.alert,
                                               this.$constantes.alert.variants.SUCCESS,
                                               'Arquivo do DOM Completo inserido com sucesso!');
                    }
                })
                .catch(error => {
                    this.limparDocumentoJornal();

                    this.$helper.showAlert(this.alert,
                                           this.$constantes.alert.variants.DANGER,
                                           error.response.data.errors);
                });
        },


        excluirDocumentoJornal(){
            let message = 'Confirma a exclusão do arquivo do DOM Completo?';
            this.$helper.confirmaExclusao(this, message)
                .then(confirmado => {
                    if(confirmado){
                        this.$api.edicao.excluirDocumentoJornal(this.edicaoLocal.id)
                            .then(response => {
                                if(response.status == 200 || response.status == 201){
                                    this.limparDocumentoJornal();
                                    this.$helper.showAlert(this.alert,
                                                           this.$constantes.alert.variants.SUCCESS,
                                                           'Arquivo do DOM Completo excluído com sucesso!');
                                }
                            })
                            .catch(error => {
                                this.$helper.showAlert(this.alert,
                                                       this.$constantes.alert.variants.DANGER,
                                                       error.response.data.errors);
                            });
                    }
            });
        },

        exibirModalAssinaturaDigital(){
            this.showModalAssinaturaDigital = true;
        },

        obterArquivoDOMAssinado(arquivo, nomeOriginalArquivo, codigoAssinaturaDigital){
            this.edicaoLocal.arquivo_jornal = arquivo;
            this.edicaoLocal.documento_jornal.nome_original = nomeOriginalArquivo;
            this.edicaoLocal.documento_jornal.codigo_assinatura_digital = codigoAssinaturaDigital;
            this.showModalAssinaturaDigital = false;
            this.incluirDocumentoJornal();
        },

        abrirDocumentoJornal(documentoJornal){
            //Para documentos grandes abre a janela de download ao inves de visualizacao
            if(documentoJornal.size > this.$constantes.documentos.TAMANHO_LIMITE_PARA_VISUALIZACAO){
                let url = `${this.$env.VUE_APP_URL_API}/api/v1/documentos/${documentoJornal.nome_minio}/download`;
                if(documentoJornal.prefix){
                    url +=`?prefix=${documentoJornal.prefix}`;
                }
                window.location.assign(url);
            }else{
                this.$helper.exibirDocumento(this.$env.VUE_APP_URL_API, documentoJornal.nome_minio, documentoJornal.prefix);
            }
        },

        validarEstadoCampo(valor){
            if(this.edicaoPublicada){
                return null;
            }

            return this.$helper.validarEstadoCampo(valor, this.acao);
        },


    },

    mounted(){
        this.$nextTick(() => {
            if(this.$route.params.id === 'new'){
                this.setDefault();
                this.alteraDados();
                this.edicaoPublicada = false;
            }
        });
    },


    watch: {
        edicao: function () {
            this.edicaoLocal = this.edicao;
            this.edicaoPublicada = !this.$helper.verificaDataEdicaoMaiorAtual(this.edicao);
        },
    },

}
</script>

